import api from './api';

export const commissionService = {
  // Agent: get own commissions + summary totals
  getMyCommissions: async () => {
    return await api.get('/commissions/my');
  },

  // Owner: get all commissions — supports ?agent_id=&status=
  getAllCommissions: async (params = {}) => {
    return await api.get('/commissions', { params });
  },

  // Owner: mark commission as paid
  updateStatus: async (commissionId, status) => {
    return await api.put(`/commissions/${commissionId}/status`, { status });
  },
};
